module.exports = __webpack_public_path__ + "img/kuang6@2x.db2a3df7.png";